export default __webpack_public_path__ + "static/media/tigerbox_touch_blue.19553c3c.png";